import axios from 'axios';
import { api_prefix } from '../../Constants/constants';
import { put, takeLatest } from 'redux-saga/effects';
import { showError } from '../../CommonUtilities/CommonUtilities';
import { defaultGetResponse } from '../../GetResponse';
import {
  demoVideosReceived,
  specificdemoVideosReceived
} from '../reducers/DemoVideos';

function* getDemoVideosSaga(payload: any) {
  try {
    let fields = payload?.payload?.params?.fields;
    if (!fields) {
      fields = '';
    }
    const json = yield axios
      .get(`${api_prefix}demos/get_training_videos/?fields=${fields}`)
      .then((response) => response?.data);
    yield put(demoVideosReceived({ demoVideos: json }));
  } catch (error) {
    yield put(demoVideosReceived({ demoVideos: defaultGetResponse }));
    showError(error);
  }
}
function* getSpecificDemoVideosSaga(payload: any) {
  try {
    const videoId = payload?.payload?.params?.videoId;
    const json = yield axios
      .get(`${api_prefix}demos/${videoId}/get_specific_video/`)
      .then((response) => response?.data);
    yield put(specificdemoVideosReceived({ video_link: json.data.video }));
  } catch (error) {
    yield put(specificdemoVideosReceived({ video_link: '' }));
    showError(error);
  }
}

export default function* watchDemoVideos() {
  yield takeLatest('DemoVideos/getDemoVideos', getDemoVideosSaga);
  yield takeLatest(
    'DemoVideos/getspecificdemoVideos',
    getSpecificDemoVideosSaga
  );
}
